import React from "react";
import PageHero from "../components/PageHero";
import ContactSection from "../components/ContactSection";
import { owner, images } from "../mock/mock";
import { User, Quote } from "lucide-react";

export default function Owner() {
  return (
    <main>
      <PageHero image={images.heroEngine} eyebrow="Company" title="About the Owner" subtitle={owner.intro} />
      <section className="bg-white">
        <div className="max-w-[1400px] mx-auto px-5 md:px-8 py-20">
          <div className="grid md:grid-cols-12 gap-12">
            <div className="md:col-span-5">
              <div className="aspect-[4/5] rounded-lg border-2 border-dashed border-gray-300 bg-secondary flex flex-col items-center justify-center text-muted-foreground text-center p-6 sticky top-28">
                {owner.photo ? (
                  <img src={owner.photo} alt={owner.name} className="w-full h-full object-cover rounded-lg" />
                ) : (
                  <>
                    <User size={64} className="mb-4 text-oe-navy/40" />
                    <span className="font-semibold text-oe-navy">Owner photo</span>
                    <span className="text-sm mt-1">A picture of the owner will be added here later.</span>
                  </>
                )}
              </div>
            </div>
            <div className="md:col-span-7">
              <h2 className="oe-heading text-oe-navy text-3xl md:text-4xl mb-2">{owner.name}</h2>
              <p className="text-oe-red font-medium mb-8">{owner.role}</p>
              <div className="space-y-5">
                {owner.paragraphs.map((p, i) => (
                  <p key={i} className="text-oe-navy/80 leading-relaxed">{p}</p>
                ))}
              </div>
              <div className="relative oe-navy text-white rounded-lg p-8 md:p-10 mt-10">
                <Quote size={40} className="text-oe-red mb-4" />
                <p className="text-xl md:text-2xl leading-relaxed italic">"{owner.quote}"</p>
                <p className="text-white/60 mt-5">— {owner.name}, {owner.role}</p>
              </div>
              <div className="grid grid-cols-3 gap-5 mt-10">
                {owner.facts.map((f) => (
                  <div key={f.label} className="border border-gray-100 rounded-lg p-5 text-center">
                    <div className="text-oe-navy font-semibold text-lg">{f.value}</div>
                    <div className="text-muted-foreground text-xs mt-1 uppercase tracking-wide">{f.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <ContactSection />
    </main>
  );
}
